import { escapeHtml } from './escapeHtml';
import { getAltText } from '../api/getAltText';
const embedConfig = {
  image: {
    getAltText: true,
    generateHTML: (url, altText) => `<img src="${url}" alt="${escapeHtml(altText)}">`
  },
  video: {
    generateHTML: (url, filename) => `<iframe src="${url}" title="${filename}" webkitallowfullscreen="true" mozallowfullscreen="true" allowfullscreen="true" frameborder="0" allowtransparency="true" scrolling="no" style="width:90%; border: 1px solid gray; aspect-ratio: 16 / 9;"></iframe>`
  },
  audio: {
    generateHTML: url => `<audio controls oncontextmenu="return false;" preload="metadata" controlsList="nodownload"><source src="${url}" type="audio/mpeg"></audio>`
  },
  document: {
    generateHTML: (url, filename) => `<iframe src="${url}" title="${filename}" webkitallowfullscreen="true" mozallowfullscreen="true" allowfullscreen="true" style="width:100%; aspect-ratio: 7 / 10;"></iframe>`
  }
};
export const getEmbedHTML = async (type, url, filename, id) => {
  const config = embedConfig[type];
  if (config) {
    if (config.getAltText) {
      const altText = await getAltText(id, filename);
      return config.generateHTML(url, altText);
    } else {
      return config.generateHTML(url, filename);
    }
  } else {
    return `<a href="${url}" target="_blank">${filename}</a>`;
  }
};